// Module
var code = "<fieldset> <legend> <h3>Machines</h3> </legend> <div class=\"col-xs-12\"> <div ng-repeat=\"element in model[options.key]\" ng-init=\"localFields = createLocalFields(to.fields)\" ng-class=\"{'row-odd-repeater': $odd}\" class=\"formly control-row\" style=\"height:auto\"> <formly-form model=\"element\" fields=\"localFields\" form=\"form\"> </formly-form> </div> </div> </fieldset>";
// Exports
var _module_exports = code;;
var path = 'machines/laguna/Pages/move/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;